import { ConfirmPage } from "./ConfirmPage";

function extractToken(): string | null {
	const path = window.location.pathname;
	const match = path.match(/^\/confirm\/(.+)$/);
	return match ? decodeURIComponent(match[1]) : null;
}

export function App() {
	const token = extractToken();

	if (!token) {
		return (
			<div className="page">
				<header className="brand-header">
					<picture>
						<source srcSet="/karama-logo-white.png" media="(prefers-color-scheme: dark)" />
						<img
							src="/karama-logo-blue.png"
							alt="Karama"
							className="brand-logo"
						/>
					</picture>
				</header>
				<div className="center-message">
					<h2 className="edge-title">Invalid Link</h2>
					<p className="edge-message">
						This link doesn't contain a valid confirmation token.
					</p>
				</div>
			</div>
		);
	}

	return <ConfirmPage token={token} />;
}
